export default "__VITE_ASSET__f71f67eb__"